var popup = {
    error: (message) => {
        $('#alertToast').removeClass('text-bg-success');
        $('#alertToast').removeClass('text-bg-warning');
        $('#alertToast').addClass('text-bg-danger');
        $("#alertToast .message").text(message);
        $('#alertToast').toast('show');
    },
    success: (message) => {
        $('#alertToast').removeClass('text-bg-danger');
        $('#alertToast').removeClass('text-bg-warning');
        $('#alertToast').addClass('text-bg-success');
        $("#alertToast .message").text(message);
        $('#alertToast').toast('show');
    },
    warning: (message) => {
        $('#alertToast').removeClass('text-bg-danger');
        $('#alertToast').removeClass('text-bg-success');
        $('#alertToast').addClass('text-bg-warning');
        $("#alertToast .message").text(message);
        $('#alertToast').toast('show');
    },
    onmap: (message, className) => {
      const elem = $('<div class="map-popup">'+message+'</div>');
      $('body').append(elem);
      elem.addClass(className)

        elem.addClass("show").delay(1500).queue(function(next){
            elem.remove();
            next();
        });
    }
}

export default popup;
